import { Organization } from '@pipefyteam/types.base-types';

import { AxiosResponse } from 'axios';

import { AgentRole } from '../types';
import { apiService } from './apiService';
import { Agent, GetAgentResponse, GetAgentsListResponse } from './types/agent';

export type GetAgentParams = {
  agentRole?: AgentRole;
  externalId?: PipefyAISDKSettings['externalId'];
  organizationId: Organization['id'];
};

export const getAgent = async ({
  agentRole,
  organizationId,
  externalId,
}: GetAgentParams): Promise<Agent> => {
  if (!apiService) {
    throw new Error('API service is not initialized');
  }

  if (agentRole === 'analytics') {
    const response = await apiService.get<
      GetAgentResponse,
      AxiosResponse<GetAgentResponse>
    >(`/organizations/${organizationId}/assistants/analytics`);

    return response.data.data;
  }

  if (agentRole === 'requester') {
    if (!externalId) {
      throw new Error('ExternalId is required for requester');
    }

    // There is no endpoint to fetch assistant per externalId
    // So we need to fetch all assistants and find the one with the externalId
    const response = await apiService.get<
      GetAgentsListResponse,
      AxiosResponse<GetAgentsListResponse>
    >(`/organizations/${organizationId}/assistants`);

    const included = response.data.included.find(
      (included) => included.attributes.external_id === externalId
    );

    const botId = included?.attributes.bot_id;
    const agent = response.data.data.find((agent) => agent.id === botId);

    if (!agent) {
      throw new Error('Requester agent not found');
    }

    return agent;
  }

  throw new Error('Agent not found');
};
